function doAnimations() {
    const windowBottom = window.scrollY + window.innerHeight;

    const elements = document.querySelectorAll(".animatable-js");

    console.log(elements.length);

    elements.forEach((el) => {
        const rect = el.getBoundingClientRect();
        const elTop = rect.top + window.scrollY;
        const elHeight = rect.height;

        if (elTop + elHeight - 20 < windowBottom) {
            el.classList.remove("animatable-js");
            el.classList.add("animated-js");
        }
    });
}

document.addEventListener("DOMContentLoaded", () => {
    doAnimations();
    window.addEventListener("scroll", doAnimations);
});